export default "__VITE_ASSET__158ae758__"